module.exports = __webpack_public_path__ + "img/pay-value6.82790ea0.png";